import { useMemo } from "react";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getWorkerTimeDays } from "../api/workers";
import type { TimeDay } from "../api/types";

const STALE_MS = 30_000;

/** Temps d'un worker sur une période, calculé par le serveur — le même calcul que
 * la feuille de temps, les compteurs du profil et la vue manager. La clé commence
 * par celle de la timeline : toute édition ou pointage qui invalide la timeline
 * relit aussi ces jours. */
export function workerTimeDaysQuery(
  workerUrl: string,
  start: string,
  end: string,
  enabled = true,
) {
  return queryOptions({
    queryKey: [
      "tawa",
      "worker",
      "timeline",
      "time-days",
      workerUrl,
      start,
      end,
    ],
    queryFn: () =>
      getWorkerTimeDays({ worker_url: workerUrl, from: start, to: end }),
    enabled: enabled && !!workerUrl && !!start && !!end,
    staleTime: STALE_MS,
  });
}

export function useWorkerTimeDays(
  workerUrl: string,
  start: string,
  end: string,
  options?: { enabled?: boolean },
): {
  daysByKey: Map<string, TimeDay>;
  isLoading: boolean;
  isError: boolean;
} {
  const q = useQuery(
    workerTimeDaysQuery(workerUrl, start, end, options?.enabled ?? true),
  );
  const daysByKey = useMemo(
    () => new Map((q.data?.days ?? []).map((d) => [d.date, d])),
    [q.data],
  );
  return { daysByKey, isLoading: q.isLoading, isError: q.isError };
}
